export const traumatologyAndOrthopedicsConst = {
  path: "/single-programs/traumatology-and-orthopedics",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ТРАВМАТОЛОГИЯ И ОРТОПЕДИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Травматология и ортопедия — восстановление движения, возвращение к жизни</h2>
      <p>
        равматология и ортопедия — это медицинская область, занимающаяся диагностикой, лечением и реабилитацией заболеваний и травм
        опорно-двигательной системы. Специалисты работают с пациентами, которые перенесли переломы, вывихи, спортивные травмы, а также с
        теми, кто страдает от врождённых или приобретённых деформаций костей и суставов.
      </p>
      <p>Это профессия, в которой каждый день ты помогаешь людям снова ходить, двигаться, жить активно и без боли.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Современные методы диагностики травм и патологий суставов</li>
        <li>Оперативное лечение переломов и повреждений костей</li>
        <li>Эндопротезирование суставов</li>
        <li>Спортивная травматология и восстановление</li>
        <li>Консервативное лечение заболеваний позвоночника и конечностей</li>
        <li>Физиотерапия и реабилитация</li>
        <li>Детская ортопедия и коррекция деформаций</li>
        <li>Медико-биомеханические технологии</li>
      </ul>
      <p>Обучение сочетает теоретические дисциплины с большим количеством клинической практики и симуляционных курсов.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Травматолог в стационаре или клинике экстренной помощи</li>
        <li>Ортопед, специалист по восстановлению двигательной функции</li>
        <li>Врач спортивной медицины в реабилитационных центрах и командах</li>
        <li>Хирург-ортопед по протезированию и коррекции деформаций</li>
        <li>Консультант в частных медицинских центрах и санаториях</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€65,000 до €120,000 в год,</strong> в зависимости от квалификации, страны и уровня учреждения
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Преподавание от практикующих хирургов и травматологов</li>
        <li>Возможность очного и дистанционного обучения (с модулями в ЕС)</li>
        <li>Собственные учебные базы, оснащенные симуляторами</li>
        <li>Стажировки в университетских больницах Европы</li>
        <li>Поддержка карьерного роста и трудоустройства</li>
        <li>Обучение на русском или английском языке по выбору</li>
      </ul>
      <p>
        Травматология и ортопедия — это медицина действия. Быстрая диагностика, точные решения, возвращение пациентам подвижности и качества
        жизни. Эта профессия требует силы, знаний и чуткости.
      </p>
      <h2>Как поступить?</h2>
      <p>
        Поступить легко — просто оставьте заявку, и приёмная комиссия свяжется с вами, поможет с выбором формы обучения, оформлением
        документов и подачей заявки в университет.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Травматология и ортопедия — восстановление движения, возвращение к жизни
    Травматология и ортопедия — это медицинская область, занимающаяся диагностикой, лечением и реабилитацией заболеваний и травм опорно-двигательной системы. Специалисты работают с пациентами, которые перенесли переломы, вывихи, спортивные травмы, а также с теми, кто страдает от врождённых или приобретённых деформаций костей и суставов.
    Это профессия, в которой каждый день ты помогаешь людям снова ходить, двигаться, жить активно и без боли.

    Что вы будете изучать?
    • Современные методы диагностики травм и патологий суставов
    • Оперативное лечение переломов и повреждений костей
    • Эндопротезирование суставов
    • Спортивная травматология и восстановление
    • Консервативное лечение заболеваний позвоночника и конечностей
    • Физиотерапия и реабилитация
    • Детская ортопедия и коррекция деформаций
    • Медико-биомеханические технологии
    Обучение сочетает теоретические дисциплины с большим количеством клинической практики и симуляционных курсов.

    Кем можно работать после окончания?
    • Травматолог в стационаре или клинике экстренной помощи
    • Ортопед, специалист по восстановлению двигательной функции
    • Врач спортивной медицины в реабилитационных центрах и командах
    • Хирург-ортопед по протезированию и коррекции деформаций
    • Консультант в частных медицинских центрах и санаториях

    Средний доход в Европе:
    от €65,000 до €120,000 в год, в зависимости от квалификации, страны и уровня учреждения

    Почему выбирают нас?
    • Преподавание от практикующих хирургов и травматологов
    • Возможность очного и дистанционного обучения (с модулями в ЕС)
    • Собственные учебные базы, оснащенные симуляторами
    • Стажировки в университетских больницах Европы
    • Поддержка карьерного роста и трудоустройства
    • Обучение на русском или английском языке по выбору

    Травматология и ортопедия — это медицина действия. Быстрая диагностика, точные решения, возвращение пациентам подвижности и качества жизни. Эта профессия требует силы, знаний и чуткости.

    Как поступить?
    Поступить легко — просто оставьте заявку, и приёмная комиссия свяжется с вами, поможет с выбором формы обучения, оформлением документов и подачей заявки в университет.
  `,
};
